import { render, staticRenderFns } from "./gqcgCb.vue?vue&type=template&id=535c2186&scoped=true"
import script from "./gqcgCb.vue?vue&type=script&lang=js"
export * from "./gqcgCb.vue?vue&type=script&lang=js"
import style0 from "./gqcgCb.vue?vue&type=style&index=0&id=535c2186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c2186",
  null
  
)

export default component.exports